module.exports = __webpack_public_path__ + "static/media/logo.28a88333.png";